import client from './client';

export const forbiddenObjectsApi = {
  getAll() {
    return client.get('/forbidden-objects');
  },
  create(name, imageFile) {
    const formData = new FormData();
    formData.append('name', name);
    formData.append('image', imageFile);
    return client.post('/forbidden-objects', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  delete(id) {
    return client.delete(`/forbidden-objects/${id}`);
  },
};
